import { render, staticRenderFns } from "./TheStorage.vue?vue&type=template&id=b60eecca&scoped=true&"
import script from "./TheStorage.vue?vue&type=script&lang=js&"
export * from "./TheStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60eecca",
  null
  
)

export default component.exports